import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    Input,
    Label,
    Row,
    Col,
} from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { editProperty } from "service/api";

const EditPropertyModal = ({ isOpen, toggle, property, onSave }) => {
    // State for form data
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        price: "",
        location: "",
        city: "",
        state: "",
        country: "",
        pin_code: "",
        bedrooms: "",
        bathrooms: "",
        area_sqft: "",
        year_built: "",
        features: "",
        is_featured: "",
        posted_by: "",
        contact_info: "",
        images: [],
        property_details: [{}],
    });

    const [selectedPropertyType, setSelectedPropertyType] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [videoLinks, setVideoLinks] = useState([""]);
    const [Facilities, setFacilities] = useState([""]);
    const [Specifications, setSpecification] = useState([{ category: "", detail: "" }]);
    const [formRows, setFormRows] = useState([{ id: 1 }]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Property type and status options (same as in your Addproperty component)
    const statusOptions = [
        { value: "For Sale", label: "For Sale" },
        // ... other status options
    ];

    const propertyTypes = [
        { value: "Apartment", label: "Apartment" },
        // ... other property types
    ];
    // Safe JSON parsing function
    const safeJsonParse = (str) => {
        try {
            return str ? JSON.parse(str) : [];
        } catch (e) {
            console.error("Failed to parse JSON:", e);
            return [];
        }
    };
    // Initialize form data when property prop changes
    // useEffect(() => {
    //     if (property) {
    //         setFormData({
    //             title: property.title || "",
    //             description: property.description || "",
    //             price: property.price || "",
    //             location: property.location || "",
    //             city: property.city || "",
    //             state: property.state || "",
    //             country: property.country || "",
    //             pin_code: property.pin_code || "",
    //             bedrooms: property.bedrooms || "",
    //             bathrooms: property.bathrooms || "",
    //             area_sqft: property.area_sqft || "",
    //             year_built: property.year_built || "",
    //             features: property.features || "",
    //             is_featured: property.is_featured || "",
    //             posted_by: property.posted_by || "",
    //             contact_info: property.contact_info || "",
    //             images: property.images || [],
    //             property_details: property.property_details || [{}],
    //         });

    //         setSelectedPropertyType(
    //             propertyTypes.find(opt => opt.value === property.property_type) || null
    //         );
    //         setSelectedStatus(
    //             statusOptions.find(opt => opt.value === property.status) || null
    //         );

    //         // Use safeJsonParse instead of direct JSON.parse
    //         setVideoLinks(safeJsonParse(property.video_links));
    //         setFacilities(safeJsonParse(property.facilities));
    //         setSpecification(safeJsonParse(property.specifications));

    //         // Handle property_details specially since it's required for formRows
    //         try {
    //             const details = property.property_details ? JSON.parse(property.property_details) : [{}];
    //             setFormRows(details.length > 0 ? details : [{ id: 1 }]);
    //         } catch (e) {
    //             console.error("Failed to parse property_details:", e);
    //             setFormRows([{ id: 1 }]);
    //         }

    //         if (property.images && property.images.length > 0) {
    //             setImagePreviews(property.images);
    //         }
    //     }
    // }, [property]);


    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle property details row changes
    const handleRowInputChange = (id, field, value) => {
        setFormRows(prevRows =>
            prevRows.map(row => (row.id === id ? { ...row, [field]: value } : row))
        );
    };

    // Handle file upload
    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const previewUrls = files.map(file => URL.createObjectURL(file));

        setFormData(prev => ({
            ...prev,
            images: [...prev.images, ...files],
        }));
        setImagePreviews(prev => [...prev, ...previewUrls]);
    };

    // Remove image preview
    const removeImagePreview = (index) => {
        const updatedPreviews = [...imagePreviews];
        updatedPreviews.splice(index, 1);
        setImagePreviews(updatedPreviews);

        const updatedFiles = [...formData.images];
        updatedFiles.splice(index, 1);
        setFormData(prev => ({ ...prev, images: updatedFiles }));
    };

    // Handle form submission
    // const handleSubmit = (e) => {
    //     e.preventDefault();

    //     // Prepare the data to be saved
    //     const updatedProperty = {
    //         ...formData,
    //         property_type: selectedPropertyType?.value || "",
    //         status: selectedStatus?.value || "",
    //         video_links: JSON.stringify(videoLinks),
    //         facilities: JSON.stringify(Facilities),
    //         specifications: JSON.stringify(Specifications),
    //         property_details: JSON.stringify(formRows),
    //     };

    //     onSave(updatedProperty);
    //     toggle();
    // };

    useEffect(() => {
        if (property) {
            setFormData({
                title: property.title || "",
                description: property.description || "",
                price: property.price || "",
                location: property.location || "",
                city: property.city || "",
                state: property.state || "",
                country: property.country || "",
                pin_code: property.pin_code || "",
                bedrooms: property.bedrooms || "",
                bathrooms: property.bathrooms || "",
                area_sqft: property.area_sqft || "",
                year_built: property.year_built || "",
                features: property.features || "",
                is_featured: property.is_featured || "",
                posted_by: property.posted_by || "",
                contact_info: property.contact_info || "",
                images: property.images || [],
                property_details: property.property_details || [{}],
            });

            setSelectedPropertyType(
                propertyTypes.find(opt => opt.value === property.property_type) || null
            );
            setSelectedStatus(
                statusOptions.find(opt => opt.value === property.status) || null
            );

            setVideoLinks(safeJsonParse(property.video_links));
            setFacilities(safeJsonParse(property.facilities));
            setSpecification(safeJsonParse(property.specifications));

            try {
                const details = property.property_details ? JSON.parse(property.property_details) : [{}];
                setFormRows(details.length > 0 ? details : [{ id: 1 }]);
            } catch (e) {
                console.error("Failed to parse property_details:", e);
                setFormRows([{ id: 1 }]);
            }

            if (property.images && property.images.length > 0) {
                setImagePreviews(property.images);
            }
        }
    }, [property]);

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Prepare FormData for multipart upload
        const formPayload = new FormData();

        // Append all the basic fields
        formPayload.append("title", formData.title);
        formPayload.append("description", formData.description);
        formPayload.append("price", formData.price);
        formPayload.append("location", formData.location);
        formPayload.append("city", formData.city);
        formPayload.append("state", formData.state);
        formPayload.append("country", formData.country);
        formPayload.append("pin_code", formData.pin_code);
        formPayload.append("property_type", selectedPropertyType?.value || "");
        formPayload.append("bedrooms", formData.bedrooms);
        formPayload.append("bathrooms", formData.bathrooms);
        formPayload.append("area_sqft", formData.area_sqft);
        formPayload.append("year_built", formData.year_built);
        formPayload.append("status", selectedStatus?.value || "");
        formPayload.append("features", formData.features);
        formPayload.append("is_featured", formData.is_featured);
        formPayload.append("posted_by", formData.posted_by);
        formPayload.append("contact_info", formData.contact_info);

        // Append the JSON data
        formPayload.append("video_links", JSON.stringify(videoLinks));
        formPayload.append("facilities", JSON.stringify(Facilities));
        formPayload.append("specifications", JSON.stringify(Specifications));
        formPayload.append("property_details", JSON.stringify(formRows));

        // Append images (new files only)
        if (formData.images && formData.images.length > 0) {
            formData.images.forEach((image) => {
                if (image instanceof File) {
                    formPayload.append("images", image);
                }
            });
        }

        try {
            // Call your editProperty API
            const response = await editProperty(property.id, formPayload);

            if (response.success) {
                toast.success("Property updated successfully!");
                onSave(); // Refresh the parent component's data
                toggle(); // Close the modal
            } else {
                toast.error(response.message || "Failed to update property");
            }
        } catch (error) {
            console.error("Error updating property:", error);
            toast.error("An error occurred while updating the property");
        } finally {
            setIsSubmitting(false);
        }
    };


    // Helper functions for dynamic fields (similar to your Addproperty component)
    const addVideoField = () => setVideoLinks([...videoLinks, ""]);
    const removeVideoField = (index) => setVideoLinks(videoLinks.filter((_, i) => i !== index));
    const handleVideoChange = (index, value) => {
        const newLinks = [...videoLinks];
        newLinks[index] = value;
        setVideoLinks(newLinks);
    };

    const addFacilityField = () => setFacilities([...Facilities, ""]);
    const removeFacilityField = (index) => setFacilities(Facilities.filter((_, i) => i !== index));
    const handleFacilityChange = (index, value) => {
        const newFacilities = [...Facilities];
        newFacilities[index] = value;
        setFacilities(newFacilities);
    };

    const addSpecificationField = () => setSpecification([...Specifications, { category: "", detail: "" }]);
    const removeSpecificationField = (index) => setSpecification(Specifications.filter((_, i) => i !== index));
    const handleSpecificationChange = (index, field, value) => {
        const updated = [...Specifications];
        updated[index][field] = value;
        setSpecification(updated);
    };

    const addFormRow = () => {
        setFormRows([...formRows, { id: formRows.length + 1 }]);
    };

    const deleteFormRow = (id) => {
        if (formRows.length > 1) {
            setFormRows(formRows.filter(row => row.id !== id));
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable>
            <ModalHeader toggle={toggle}>Edit Property</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col sm={6}>
                            <Label>Title</Label>
                            <Input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={6}>
                            <Label>Price</Label>
                            <Input
                                type="text"
                                name="price"
                                value={formData.price}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col sm={4}>
                            <Label>Property Type</Label>
                            <Select
                                options={propertyTypes}
                                value={selectedPropertyType}
                                onChange={setSelectedPropertyType}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Status</Label>
                            <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={setSelectedStatus}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Year Built</Label>
                            <Input
                                type="text"
                                name="year_built"
                                value={formData.year_built}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col sm={6}>
                            <Label>Location</Label>
                            <Input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={6}>
                            <Label>City</Label>
                            <Input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col sm={4}>
                            <Label>State</Label>
                            <Input
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Country</Label>
                            <Input
                                type="text"
                                name="country"
                                value={formData.country}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Pin Code</Label>
                            <Input
                                type="text"
                                name="pin_code"
                                value={formData.pin_code}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col sm={4}>
                            <Label>Bedrooms</Label>
                            <Input
                                type="text"
                                name="bedrooms"
                                value={formData.bedrooms}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Bathrooms</Label>
                            <Input
                                type="text"
                                name="bathrooms"
                                value={formData.bathrooms}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col sm={4}>
                            <Label>Area (sqft)</Label>
                            <Input
                                type="text"
                                name="area_sqft"
                                value={formData.area_sqft}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>

                    {/* Property Details Rows */}
                    {formRows.map((row, index) => (
                        <div key={row.id} className="mb-4 p-3 border rounded">
                            <Row>
                                <Col sm={3}>
                                    <Label>Plot Area (sqft)</Label>
                                    <Input
                                        type="text"
                                        value={row.plotArea || ""}
                                        onChange={(e) => handleRowInputChange(row.id, "plotArea", e.target.value)}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Label>Carpet Area (sqft)</Label>
                                    <Input
                                        type="text"
                                        value={row.carpetArea || ""}
                                        onChange={(e) => handleRowInputChange(row.id, "carpetArea", e.target.value)}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Label>Built-up Area (sqft)</Label>
                                    <Input
                                        type="text"
                                        value={row.builtArea || ""}
                                        onChange={(e) => handleRowInputChange(row.id, "builtArea", e.target.value)}
                                    />
                                </Col>
                                <Col sm={3} className="d-flex align-items-end">
                                    <Button
                                        color="danger"
                                        onClick={() => deleteFormRow(row.id)}
                                        disabled={formRows.length <= 1}
                                    >
                                        Delete Row
                                    </Button>
                                </Col>
                            </Row>
                            {/* Add more fields as needed */}
                        </div>
                    ))}
                    <Button color="primary" onClick={addFormRow} className="mb-3">
                        Add Property Detail Row
                    </Button>

                    {/* Facilities */}
                    <div className="mb-3">
                        <Label>Facilities</Label>
                        {Facilities.map((facility, index) => (
                            <div key={index} className="d-flex mb-2">
                                <Input
                                    type="text"
                                    value={facility}
                                    onChange={(e) => handleFacilityChange(index, e.target.value)}
                                />
                                <Button
                                    color="danger"
                                    onClick={() => removeFacilityField(index)}
                                    className="ms-2"
                                >
                                    Remove
                                </Button>
                            </div>
                        ))}
                        <Button color="primary" onClick={addFacilityField}>
                            Add Facility
                        </Button>
                    </div>

                    {/* Specifications */}
                    <div className="mb-3">
                        <Label>Specifications</Label>
                        {Specifications.map((spec, index) => (
                            <Row key={index} className="mb-2">
                                <Col sm={5}>
                                    <Input
                                        placeholder="Category"
                                        value={spec.category}
                                        onChange={(e) => handleSpecificationChange(index, "category", e.target.value)}
                                    />
                                </Col>
                                <Col sm={5}>
                                    <Input
                                        placeholder="Detail"
                                        value={spec.detail}
                                        onChange={(e) => handleSpecificationChange(index, "detail", e.target.value)}
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Button
                                        color="danger"
                                        onClick={() => removeSpecificationField(index)}
                                    >
                                        Remove
                                    </Button>
                                </Col>
                            </Row>
                        ))}
                        <Button color="primary" onClick={addSpecificationField}>
                            Add Specification
                        </Button>
                    </div>

                    {/* Video Links */}
                    <div className="mb-3">
                        <Label>Video Links</Label>
                        {videoLinks.map((link, index) => (
                            <div key={index} className="d-flex mb-2">
                                <Input
                                    type="text"
                                    value={link}
                                    onChange={(e) => handleVideoChange(index, e.target.value)}
                                    placeholder="Enter video URL"
                                />
                                <Button
                                    color="danger"
                                    onClick={() => removeVideoField(index)}
                                    className="ms-2"
                                >
                                    Remove
                                </Button>
                            </div>
                        ))}
                        <Button color="primary" onClick={addVideoField}>
                            Add Video Link
                        </Button>
                    </div>

                    {/* Images */}
                    <div className="mb-3">
                        <Label>Images</Label>
                        <Input type="file" multiple onChange={handleFileUpload} />
                        <div className="d-flex flex-wrap mt-2">
                            {imagePreviews.map((preview, index) => (
                                <div key={index} className="position-relative m-2" style={{ width: "100px" }}>
                                    <img
                                        src={preview}
                                        alt={`Preview ${index}`}
                                        className="img-thumbnail"
                                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                    />
                                    <Button
                                        color="danger"
                                        size="sm"
                                        className="position-absolute top-0 end-0"
                                        onClick={() => removeImagePreview(index)}
                                    >
                                        ×
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </div>

                    <Row className="mb-3">
                        <Col sm={12}>
                            <Label>Description</Label>
                            <Input
                                type="textarea"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                rows={5}
                            />
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? "Saving..." : "Save Changes"}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditPropertyModal;